'use strict';

var trendsConfig = require('../config/JQXGridCellTreatment.json');
var trendProperties = {
  FLIGHT: trendsConfig.flightAnalysisTrendProperties,
  MARKET: trendsConfig.marketAnalysisTrendProperties,
  LIVE_DATA: trendsConfig.liveDataProperties,
  TIMESTAMP: trendsConfig.timestampProperties,
  NON_NUMERIC_VALUES: trendsConfig.nonNumericValuesProperties
};
var gridTrendMap = {
  'market-demand-analysis': trendProperties.MARKET,
  'market-product-group-analysis': trendProperties.MARKET,
  'service-demand-analysis': trendProperties.MARKET,
  'service-flight-analysis': trendProperties.MARKET,
  'cabin-flight-analysis': trendProperties.FLIGHT,
  'class-flight-analysis': trendProperties.FLIGHT,
  'segment-flight-analysis': trendProperties.FLIGHT,
  'inventory-management': trendProperties.FLIGHT,
  'overbooking-management': trendProperties.FLIGHT,
  'flight-summary': trendProperties.FLIGHT
};
var JQXGridCellTreatementTrendConstants = {
  FLIGHT_PROPERTIES: trendProperties.FLIGHT,
  MARKET_PROPERTIES: trendProperties.MARKET,
  LIVE_DATA_PROPERTIES: trendProperties.LIVE_DATA,
  TIMESTAMP_PROPERTIES: trendProperties.TIMESTAMP,
  NON_NUMERIC_VALUES_PROPERTIES: trendProperties.NON_NUMERIC_VALUES,
  GRID_TRENDS: gridTrendMap
};
module.exports = JQXGridCellTreatementTrendConstants;